import type { CurrencyCode } from '../../../../../types';
import type { NumberSettings, NumberFormat } from '../types';
import { FORMATS_SUPPORTED_CURRENCY_OVERRIDES } from '../constants';

export const needsOverrideCurrency = (
    format: NumberFormat,
    settings: NumberSettings,
    overrideCurrency?: CurrencyCode | undefined
): overrideCurrency is CurrencyCode => {
    if (!overrideCurrency)  return false;

    if (!FORMATS_SUPPORTED_CURRENCY_OVERRIDES.has(format)) return false;

    return overrideCurrency !== settings.currency;
};
